type ClassValue = string | false | null | undefined;

/**
 * Joins class names, dropping anything falsy.
 *
 * CSS Module lookups are typed `string | undefined` under
 * `noUncheckedIndexedAccess`, so template-literal concatenation would smuggle
 * the literal "undefined" into `class`. This drops it instead.
 */
export function cx(...values: ClassValue[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
